/* eslint-disable react-hooks/exhaustive-deps */
// @ts-nocheck
import { Col, Container, Row, Breadcrumb, BreadcrumbItem, Navbar, LinkList, NavItem, NavLink, Icon, Chip, ChipLabel, Spinner, Card, CardBody, CardTitle, CardText } from 'design-react-kit';
import React, { useEffect, useState, useContext } from 'react';
import { useParams } from 'react-router-dom';
import ApiService from "../../../services/api";
import { CategoryClass } from '../../categories/models/category';
import { NewsClass, NewsContentSections } from '../models/news';
import Page404 from '../../pages/page404';
import WidgetPageRating from 'pa_kit/apps/page_evaluation/components/widget_page_rating';
import WidgetContacts from 'pa_kit/apps/contacts/components/widget_contacts';
import parse from 'html-react-parser';
import moment from 'moment';
import 'moment/locale/it';
import env from '../../../env';
import { ActaAuthContext } from "pa_kit/auth";
import { Helmet } from "react-helmet-async";
import ShareButtons from 'apps/utils/share_buttons';


const NewsContent = (props) => {

    const news = props.news;

    return (
        <Container className="mb-5">
            <Row className="news-content-wrapper">
                <Col lg={4} className="news-section-sidebar">
                    <div className='sticky-top navbar-wrapper'>
                        <Navbar expand='lg' className='it-navscroll-wrapper it-top-navscroll'>
                            <div className='menu-wrapper w-100'>
                                <LinkList wrapperClassName='menu-link-list' header={<h3>Indice della pagina</h3>}>
                                {Object.keys(NewsContentSections).map((key, index) => ((news?.content[key] && (Array.isArray(news?.content[key]) ? (news?.content[key].length > 0) : (news?.content[key].description !== '' && news?.content[key].description !== null))) || (key === 'office' && news.office !== '' && news.office !== null)) &&
                                    <NavItem key={"key_sectionlink_" + key} >
                                        <NavLink href={"#" + key} className="sidebar-nav-link">{Object.values(NewsContentSections)[index]}</NavLink>
                                    </NavItem>
                                )}
                                </LinkList>
                            </div>
                        </Navbar>
                    </div>
                </Col>
                <Col lg={8} className="news-section-content">                    
                    
                    {news.image && news.image !== '' && news.image.substring(news.image.lastIndexOf('/') + 1) !== 'default.jpg' &&  <>
                        <div>
                            <img src={env.BACKEND_BASE_URL + news.image} title={news.image_description || news.title} alt={news.image_description || news.title} />
                        </div> 
                        <div>
                            <p className="news-image-description mt-2">{news.image_description}</p>
                        </div>            
                        </>                               
                    }                                            
                    
                    {Object.keys(NewsContentSections).map((key, index) => (news?.content[key] || key === 'office') &&
                        <div key={"key_newsSection_" + index} className="mb-4">
                            
                            {key !== 'office' && news?.content[key].description && <>    
                                <h4 className="news-content-title" id={key}>{ Object.values(NewsContentSections)[index] }</h4>                        
                                <div className="news-content-description">
                                    { parse(news.content[key].description) }
                                </div>
                                </>
                            }
                            
                            {key === 'attachments' && news.content[key].length > 0 && <>
                                <h4 className="news-content-title" id={key}>{ Object.values(NewsContentSections)[index] }</h4>
                                <Row>
                                    {news.content[key].map((attachment) =>
                                        <Col key={"key_attachmentlink_" + attachment.name} lg={6} className="mb-2">                                            
                                           <div className="attachment-box">
                                                <a href={env.BACKEND_BASE_URL + encodeURIComponent(attachment.url)} className="text-decoration-none" title={attachment.name} target="_blank" rel="noreferrer"><Icon icon="it-clip" /> {attachment.name}</a>
                                            </div>
                                        </Col>
                                    )}
                                </Row>
                                </>
                            }

                            {key === 'office' && news.office &&
                                <>
                                <h4 className="news-content-title" id={key}>{ Object.values(NewsContentSections)[index] }</h4>
                                <p className="title-xsmall-semi-bold mb-1">Questa notizia è gestita da</p>
                                <Row>
                                    <Col lg="6" className="mb-2">
                                        <Card className="office-card-box">
                                            <CardBody className="office-card">
                                                <Row>
                                                    <Col lg="8" xs="8">
                                                        <CardTitle tag='h5' className="mb-1">
                                                            <a href={'/' + news.office.slug + '/'} title={news.office.name}>{news.office.name}</a>
                                                        </CardTitle>
                                                        <CardText>
                                                            Ufficio
                                                        </CardText>
                                                    </Col>
                                                    <Col lg={{size: 3, offset: 1}} xs="4">
                                                        <Icon icon="it-pa" size="lg" />
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                                </>
                            }
                        </div>

                    )}

                    <div className="mt-5">
                        <h5>Ultimo aggiornamento</h5>
                        <p>{moment(news.last_update).format('D MMMM Y')}</p>
                    </div>
                        
                </Col>
            </Row>
        </Container>
    )
}

const PageNewsArticle = () => {

    const auth = useContext(ActaAuthContext);

    const organization = auth.organization;

    const isActagovWebsiteEditor = auth.user && auth.user.isActagovWebsiteEditor();
    const isActagovContentEditor = auth.user && auth.user.isActagovContentEditor();

    const actagov_config = auth.organization.active_licenses?.services?.actagov;

    let { categorySlug } = useParams();
    let { newsSlug } = useParams();

    const [ news, setNews ] = useState();
    const [ category, setCategory ] = useState();    
    const [ isLoading, setIsLoading ] = useState(true);
    const [ pageNotFound, setPageNotFound ] = useState(false);

    const [ mainSection, setMainSection ] = useState({});

    const fetchCategory = async() => {
        try {
            const category = await ApiService.getCategory(categorySlug);
            setCategory(new CategoryClass(category));
        } catch (error) {
            setPageNotFound(true);
        }       
    }

    const fetchNews = async() => {
        try {
            const news = await ApiService.getNews(newsSlug);
            setNews(new NewsClass(news));
            setIsLoading(false);
        } catch (error) {
            setPageNotFound(true);
        }
    }

    const fetchMainSections = async() => {
        const mainSectionsData = await ApiService.getMainSections();
        const mainSection = mainSectionsData.filter(main_section => main_section.id === 3); // Novità
        setMainSection(mainSection[0]);
    }

    useEffect(() => {
        fetchCategory();
        fetchNews();
        fetchMainSections();
    }, []);    
    
       
    if(pageNotFound) return <Page404 />;
    if(isLoading) return <Container style={{ padding: "50px" }}><Spinner active /></Container>; 
    return <>
        <Helmet>
            <title>{news && news.title + ' | ' + organization.name}</title>
            <meta name="description" content={news.meta_description} />
            {news.image !== '' && <meta property="og:image" content={env.BACKEND_BASE_URL + news.image} />}
        </Helmet>
        <Container fluid className="p-0 news-main-wrapper">
            <Container className="pt-5 pb-5 px-3">
                <Row>
                    <Col>
                        <Breadcrumb>
                            <BreadcrumbItem>
                                <a href='/'>Home</a>
                                <span className='separator'>/</span>
                            </BreadcrumbItem>
                            <BreadcrumbItem>
                                <a href='/novita/'>{mainSection.name}</a>
                                <span className='separator'>/</span>
                            </BreadcrumbItem>
                            <BreadcrumbItem>
                                <a href={'/novita/' + (category && category.slug) + '/'}>{category && category.name}</a>
                                <span className='separator'>/</span>
                            </BreadcrumbItem>
                            <BreadcrumbItem active>
                                {news.title}
                            </BreadcrumbItem>
                        </Breadcrumb>
                    </Col>
                </Row>                
                {isActagovContentEditor && 
                    <Row>
                        <Col className="text-end">
                            <a href={'/admin/edit-news/' + news.slug} className="me-2" title="Modifica">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
                                    <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
                                    <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/>
                                </svg>    
                            </a>
                        </Col>
                    </Row>
                }
                <Row className="news-wrapper">
                    <Col className="py-2" lg={7}>
                        <h1>{news.title}</h1>
                        <div className="news-excerpt-wrapper mt-3">
                            {news.content.excerpt.description && news.content.excerpt.description !== ''
                                ? parse(news.content.excerpt.description)
                                : 'Dettagli della notizia'}
                        </div>
                    </Col>
                    <Col className="pt-5 pt-lg-2" lg={{ offset: 1, size: 4 }}>
                        <ShareButtons url={actagov_config?.frontend_url + 'novita/' + news.category.slug + '/' + news.slug + '/'} title={news.title} />
                        {news.tags.length > 0 &&
                            <Row>
                                <span className="mb-2 small">Argomenti</span>
                            </Row>
                        }
                        {news.tags && news.tags.map((tag) => 
                            <a href={'/argomenti/' + tag.slug + '/'} key={tag.id} className="text-decoration-none me-2" title={tag.name}>
                                <Chip simple color='primary'>
                                    <ChipLabel>{tag.name}</ChipLabel>
                                </Chip>
                            </a>
                        )}
                    </Col>
                    <Row className="mt-3 px-2">
                        <Col>
                            <p className="mb-2 small">Data</p>
                            <p className="fw-semibold font-monospace">{moment(news.date_news).format('D MMMM Y')}</p>
                        </Col>
                    </Row>
                </Row>
            </Container>                       

            <NewsContent news={news} />

            <Container fluid className={'rating-wrapper page-rating news-article-page-rating'}>
                <WidgetPageRating page_title={news.title} />
            </Container> 

            <Container fluid className={'contacts-wrapper news-article-page-contacts'}>
                <WidgetContacts />
            </Container> 

        </Container>
    </>;
}

export default PageNewsArticle;